import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'checkUserCanConfirmClass',
})
export class checkUserCanConfirmClassPipe implements PipeTransform {
  transform(value: any): unknown {
    let timezone = localStorage.getItem('timezone');
    if (!timezone) {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    const end = DateTime.fromFormat(value.end, 'yyyy-LL-dd HH:mm:ss', {
      zone: 'UTC',
    }).setZone(timezone);

    const now = DateTime.local().setZone(timezone);

    return end.toMillis() < now.toMillis();
  }
}
